import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchVehicleVehicleOperations,
  initializeVehicleVehicleOperationsScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleVehicleOperations,
  deleteVehicleVehicleOperations,
  saveVehicleVehicleOperationsTableState,
  importVehicleVehicleOperations,
  downloadVehicleImportTemplate,
} from "../../../redux/actions/vehicles/vehicleVehicleOperations";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import VehicleVehicleOperations from '../../../component/Vehicles/VehicleVehicleOperations';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleVehicleOperationsScreen(props) {
  const {
    fetchVehicleVehicleOperations,
    initVehicleVehicleOperationsScreen,
    showPageLevelLoader,
    vehicleVehicleOperationsListview,
    paginationInfo,
    screenPermissions,
    exportVehicleVehicleOperations,
    isVehicleVehicleOperationsExportError,
    isVehicleVehicleOperationsExportSuccess,
    isLoading,
    deleteVehicleVehicleOperations,
    isVehicleVehicleOperationsDeleteSuccess,
    isVehicleVehicleOperationsDeleteError,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    savedTableState,
    saveVehicleVehicleOperationsTableState,
    importVehicleVehicleOperations,
    downloadVehicleImportTemplate,
    isVehicleVehicleOperationsImportSuccess,
    isVehicleVehicleOperationsImportError,
    vehicleImportResult,
    isDownloadTemplateLoading,
  } = props;
  const navigate = useNavigate();
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    const isISODateString = (str) => typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    const formatFilterValue = (value) => {
      if (value instanceof Date) return formatDate(value, DATE_STRATEGY.DATE_ISO);
      if (isISODateString(value)) return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      return value;
    };
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(state.filters[key].value),
          });
        }
      });
    }
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId"),
    };
  };

  useEffect(() => {
    initVehicleVehicleOperationsScreen();
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    if (savedParams) {
      fetchVehicleVehicleOperations(savedParams);
    } else {
      fetchVehicleVehicleOperations({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableStateChange = (tableState) => {
    saveVehicleVehicleOperationsTableState(tableState);
  };

  const loadLazyData = (props) => {
    let newPyload = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchVehicleVehicleOperations(newPyload);
  };
  const handleCreateVehicleVehicleOperations = () => {
    navigate(APP_URLS.VEHICLE_VEHICLEOPERATIONS.CREATE);
  }
  const editVehicleVehicleOperationsRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_VEHICLEOPERATIONS.EDIT, {
      id,
    });
    navigate(path);
  };
  const handleImportVehicles = (file) => {
    importVehicleVehicleOperations({ file });
  };

  const vehicleVehicleOperations = {
    handleCreateVehicleVehicleOperations,
    exportVehicleVehicleOperations,
    importVehicleVehicleOperations: handleImportVehicles,
    downloadVehicleImportTemplate,
    isVehicleVehicleOperationsImportSuccess,
    isVehicleVehicleOperationsImportError,
    vehicleImportResult,
    isDownloadTemplateLoading,
    isVehicleVehicleOperationsExportError,
    isVehicleVehicleOperationsExportSuccess,
    editVehicleVehicleOperationsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteVehicleVehicleOperations,
    isVehicleVehicleOperationsDeleteSuccess,
    isVehicleVehicleOperationsDeleteError,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    fetchVehicleVehicleOperationss: loadLazyData,
    tableData: {
      columns: vehicleVehicleOperationsListview?.columns,
      rows: vehicleVehicleOperationsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleVehicleOperations
        {...vehicleVehicleOperations}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleVehicleOperationsScreen: () => dispatch(initializeVehicleVehicleOperationsScreen()),
    fetchVehicleVehicleOperations: (payload) => dispatch(fetchVehicleVehicleOperations(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleVehicleOperations: (payload) => dispatch(exportVehicleVehicleOperations(payload)),
    deleteVehicleVehicleOperations: (payload) => dispatch(deleteVehicleVehicleOperations(payload)),
    saveVehicleVehicleOperationsTableState: (payload) => dispatch(saveVehicleVehicleOperationsTableState(payload)),
    importVehicleVehicleOperations: (payload) => dispatch(importVehicleVehicleOperations(payload)),
    downloadVehicleImportTemplate: () => dispatch(downloadVehicleImportTemplate()),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleVehicleOperationsCreateSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsCreateSuccess"
    ),
    vehicleVehicleOperationsListview: selectFromVehicleVehicleOperationsReducer(
      state,
      "vehicleVehicleOperationsListview"
    ),
    showPageLevelLoader: selectFromVehicleVehicleOperationsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleVehicleOperationsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleVehicleOperationsReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleVehicleOperationsExportError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsExportError"
    ),
    isVehicleVehicleOperationsExportSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromVehicleVehicleOperationsReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isVehicleVehicleOperationsDeleteSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsDeleteSuccess"
    ),
    isVehicleVehicleOperationsDeleteError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsDeleteError"
    ),
    savedTableState: selectFromVehicleVehicleOperationsReducer(
      state,
      "savedTableState"
    ),
    isVehicleVehicleOperationsImportSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsImportSuccess"
    ),
    isVehicleVehicleOperationsImportError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsImportError"
    ),
    vehicleImportResult: selectFromVehicleVehicleOperationsReducer(
      state,
      "vehicleImportResult"
    ),
    isDownloadTemplateLoading: selectFromVehicleVehicleOperationsReducer(
      state,
      "isDownloadTemplateLoading"
    ),
    ...ownProps,
  };
};

const selectFromVehicleVehicleOperationsReducer = (state, path) => {
  return selectVehicleVehicleOperationsReducer(state)[path];
};

const selectVehicleVehicleOperationsReducer = ({ vehicleVehicleOperationsReducer }) => {
  return vehicleVehicleOperationsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleVehicleOperationsScreen);
